import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { FileSelectionStoreService } from '../../services/file-selection-store/file-selection-store.service';

@Component({
  selector: 'baf-file-selection',
  templateUrl: './file-selection.component.html',
  styleUrls: ['./file-selection.component.css']
})
export class FileSelectionComponent implements OnInit {
  private readonly sizeSymbols = ['B', 'kB', 'MB', 'GB', 'TB'];
  readonly defaultSelectFileText = 'Wybierz plik do przesłania';

  @ViewChild('fileSelector')
  private fileSelector;

  @Input()
  selectFileText = this.defaultSelectFileText;

  @Input()
  multipleFilesMode = true;

  @Input()
  disabled = false;

  @Output()
  fileSelected = new EventEmitter<File>();

  @Output()
  fileRemoved = new EventEmitter<File>();

  constructor(private fileStore: FileSelectionStoreService) {}

  ngOnInit() {}

  get files(): File[] {
    return this.fileStore.files;
  }

  humanReadableSize(size: number): string {
    const divider = 1024;
    let index = 0;
    while (index < this.sizeSymbols.length - 1 && size >= divider) {
      size /= divider;
      index++;
    }

    return `${Math.round(size)} ${this.sizeSymbols[index]}`;
  }

  selectFiles() {
    this.fileSelector.nativeElement.click();
  }

  onFilesSelected() {
    const files = this.fileSelector.nativeElement.files;

    for (const file of files) {
      if (this.fileStore.add(file)) {
        this.fileSelected.emit(file);
      }
    }

    this.fileSelector.nativeElement.value = '';
  }

  onRemoveFile(file) {
    if (this.fileStore.remove(file)) {
      this.fileRemoved.emit(file);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/file-selection/file-selection.component.ts